export default {
  id: null,
  descricao: null,
  status: 1
}



// WEBPACK FOOTER //
// ./src/shared/models/pci/tecserviceanalysismodel.js